/**
 * Represents how the search currently follows the map.
 *
 * The mode is always derived from the store values (see
 * services/deriveViewportSearchMode.js), never stored.
 */
export default class ViewportSearchMode {

  /**
   * It represents a plain location search; the map does not narrow the results.
   */
  static get Location() {
    return this.getInstance('location');
  }

  /**
   * It represents a focused search, narrowed to the visible map area.
   */
  static get Focused() {
    return this.getInstance('focused');
  }

  /**
   * It represents a State search, refreshed for the visible part of the state.
   */
  static get StateViewport() {
    return this.getInstance('stateViewport');
  }

  /**
   * It represents a search within map (rectangular-area) search.
   */
  static get RectangularArea() {
    return this.getInstance('rectangularArea');
  }

  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new ViewportSearchMode(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(ViewportSearchMode, 'instances', { value: {} });
